module.exports = __webpack_public_path__ + "img/pano_5.f8c4505b.jpg";